/*
 * inselvolt Kompatibilitätsberater — Baureihen-Kacheln, gemeinsam für
 * Beraterseite und Produktseiten-Overlay.
 *
 * WARUM DIESE DATEI EXISTIERT (2026-08-15):
 * Beide Oberflächen beantworten dieselbe Frage — „welche Geräte passen, und was
 * leisten sie?" — und beantworteten sie bis heute in zwei verschiedenen
 * Darstellungen: die Beraterseite mit Baureihen-Kacheln und Varianten-Tabelle,
 * das Overlay mit einer eigenen Kartenliste. Zwei Auszeichnungen für dieselbe
 * Aussage laufen zwangsläufig auseinander, und für den Kunden sind es zwei
 * Produkte statt einem. Deshalb steht die Darstellung jetzt genau einmal hier.
 *
 * Diese Datei ENTSCHEIDET NICHTS. Sie bekommt fertige Ergebniszeilen aus
 * engine/berater-engine.js und stellt sie dar. Keine Kompatibilitätslogik,
 * keine Preisrechnung, kein Fetch.
 *
 * Was hier NICHT hineingehört: alles, was nur eine der beiden Oberflächen
 * kennt — Filterleiste, Vergleichsleiste, Detaildialog, Reiter. Die Kachel
 * nimmt solche Erweiterungen als Rückrufe entgegen (`optionen.aufDetail`,
 * `optionen.vergleich`), statt sie zu kennen.
 */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root) root.IVBeraterFamilien = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var nf = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 });
  var eurFormat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  var eurGenau = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  /*
   * Einheitlicher Text für Werte, die uns nicht vorliegen. „offen" oder „—"
   * las sich wie ein Platzhalter, den man übersehen darf; „nicht verfügbar"
   * sagt, was Sache ist: Zu diesem Punkt gibt es keinen belegten Wert.
   */
  var FEHLT = 'nicht verfügbar';

  /*
   * Konfiguration wird BEI BEDARF gelesen, nicht beim Laden: Auf der
   * Produktseite steht dieses Modul in der Nachladekette, auf der Beraterseite
   * im Seitenkopf — nur die späte Abfrage funktioniert in beiden Fällen.
   */
  function konfig() {
    return (typeof window !== 'undefined' && window.IV_BERATER_KONFIG) || {};
  }

  function konfigWert(name, standard) {
    return konfig()[name] || standard;
  }

  // ---------------------------------------------------------------- Helfer ---

  function el(tag, klasse, text) {
    var k = document.createElement(tag);
    if (klasse) k.className = klasse;
    if (text !== undefined && text !== null) k.textContent = text;
    return k;
  }

  function knopf(klasse, text, beiKlick) {
    var b = el('button', klasse, text);
    b.type = 'button';
    if (beiKlick) b.addEventListener('click', beiKlick);
    return b;
  }

  function leere(knoten) {
    while (knoten && knoten.firstChild) knoten.removeChild(knoten.firstChild);
    return knoten;
  }

  function istZahl(x) { return typeof x === 'number' && isFinite(x); }

  function kw(wert) { return istZahl(wert) ? nf.format(wert) + ' kW' : null; }
  function kwh(wert) { return istZahl(wert) ? nf.format(wert) + ' kWh' : null; }
  function euro(cents) { return istZahl(cents) ? eurFormat.format(cents / 100) : null; }
  // Betrag ohne Währungszeichen — die Kennzahlen im Kopf setzen das „€" als
  // eigenes, kleineres Element. Rundung wie eurFormat (ganze Euro).
  var eurZahlFormat = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });
  function euroZahl(cents) { return istZahl(cents) ? eurZahlFormat.format(cents / 100) : null; }
  function euroGenau(betrag) { return istZahl(betrag) ? eurGenau.format(betrag) : null; }

  /* Größen-Schlüssel sind Datenschlüssel. Für Kundenaugen wird daraus eine
   * Angabe — nicht-numerische Herstellerbezeichnungen bleiben, wie sie sind.
   * Seit E4 hier: vorher je eine Fassung in berater-pdp.js (Browser) und
   * pdp-bauen.js (Node), zeichengleich, aber ohne Test zusammengehalten. */
  function groesseText(schluessel) {
    return /^[\d.]+$/.test(schluessel)
      ? String(schluessel).replace('.', ',') + ' kWh'
      : String(schluessel);
  }

  /*
   * Zahlen für die Variantentabelle — OHNE Einheit, die steht im Spaltenkopf.
   * Das „bis"-Präfix für unvollständige Rechnungen bleibt: Es ist Aussage,
   * nicht Einheit. Außerhalb der Tabelle gilt leistungsText() mit Einheit,
   * dort steht der Wert allein im Raum.
   */
  function zahl(wert) { return istZahl(wert) ? nf.format(wert) : null; }

  function leistungsZahl(richtung) {
    if (!richtung || !istZahl(richtung.kw)) return null;
    return (richtung.unvollstaendig ? 'bis ' : '') + nf.format(richtung.kw);
  }

  function leistungsText(richtung) {
    if (!richtung || !istZahl(richtung.kw)) return null;
    return (richtung.unvollstaendig ? 'bis ' : '') + kw(richtung.kw);
  }

  /*
   * „2026-08-09" → „9. August 2026". Ausgeschrieben, weil ein ISO-Datum im
   * Sichtbereich technisch wirkt; ohne Datum ginge der Beleg verloren.
   * Bei unerwartetem Format bleibt der Rohwert stehen, statt zu raten.
   */
  var MONATE = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
    'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  function datumLang(iso) {
    var t = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''));
    if (!t) return String(iso || '');
    return parseInt(t[3], 10) + '. ' + MONATE[parseInt(t[2], 10) - 1] + ' ' + t[1];
  }

  /* ------------------------------------------------------------- Icons ------
   * Bewusst wenige, bewusst schlicht: Strichzeichnungen in einer Linienstärke,
   * die die Textfarbe erben. Sie sollen Orientierung geben und keine Dekoration
   * sein — ein Icon ohne Bedeutung kostet nur Aufmerksamkeit. Inline-SVG statt
   * Icon-Font oder Emoji: skaliert sauber, kein Nachladen, und in Shopify gibt
   * es keine externe Abhängigkeit.
   * -------------------------------------------------------------------------- */
  var NS = 'http://www.w3.org/2000/svg';
  var PFADE = {
    speicher: ['M7 4h10a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z', 'M10 2h4v2h-4z', 'M8 15h8'],
    wechselrichter: ['M4 5h16v14H4z', 'M8 9h8', 'M8 13h5', 'M12 19v3', 'M9 22h6'],
    erweitern: ['M12 5v14', 'M5 12h14'],
    info: ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z', 'M12 11v5', 'M12 8h.01'],
    pdf: ['M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z', 'M14 3v4h4', 'M9 13h6', 'M9 17h4'],
    extern: ['M14 4h6v6', 'M20 4l-8 8', 'M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5'],
    haken: ['M4 12l5 5L20 6'],
    blitz: ['M13 2 4 14h7l-1 8 9-12h-7z'],
    filter: ['M3 5h18', 'M6 12h12', 'M10 19h4'],
    pfeil: ['M6 9l6 6 6-6'],
    euro: ['M15 6a6 6 0 1 0 0 12', 'M4 10h8', 'M4 14h8'],
    warnung: ['M12 4l9 16H3z', 'M12 10v4', 'M12 17h.01'],
    suche: ['M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14z', 'M16 16l4 4'],
    schliessen: ['M6 6l12 12', 'M18 6L6 18'],
  };

  function icon(name, klasse) {
    var pfade = PFADE[name];
    if (!pfade) return el('span');
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '1.6');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.setAttribute('class', 'iv-icon' + (klasse ? ' ' + klasse : ''));
    pfade.forEach(function (d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      svg.appendChild(p);
    });
    return svg;
  }

  /*
   * (i)-Hilfe: erklärt, was hinter einem Wert steckt.
   *
   * Die Blase hängt am <body>, nicht am Knopf. Am Knopf war sie zwar einfacher,
   * wurde aber unsichtbar abgeschnitten: Die Varianten-Tabelle scrollt waagerecht
   * (overflow-x: auto), und ein solches Element beschneidet auch nach oben.
   * Ergebnis: Klick tat scheinbar nichts. Am body kann nichts mehr schneiden;
   * die Position rechnet JavaScript und hält sie im sichtbaren Bereich.
   *
   * Als <button>, damit sie per Tastatur und auf dem Telefon erreichbar ist —
   * ein reines Hover-Tooltip gibt es dort nicht.
   */
  var blaseKnoten = null;
  var blaseAnker = null;

  function blase() {
    if (!blaseKnoten) {
      blaseKnoten = el('div', 'iv-blase');
      blaseKnoten.setAttribute('role', 'tooltip');
      blaseKnoten.hidden = true;
      document.body.appendChild(blaseKnoten);
    }
    return blaseKnoten;
  }

  function zeigeBlase(knopfKnoten, text) {
    var b = blase();
    b.textContent = text;
    b.hidden = false;
    b.className = 'iv-blase';
    b.style.maxWidth = Math.min(300, window.innerWidth - 24) + 'px';
    b.style.left = '0px';
    b.style.top = '0px';

    var anker = knopfKnoten.getBoundingClientRect();
    var eigen = b.getBoundingClientRect();
    var links = anker.left + anker.width / 2 - eigen.width / 2;
    links = Math.max(12, Math.min(links, window.innerWidth - eigen.width - 12));
    var oben = anker.top - eigen.height - 10;
    if (oben < 8) { oben = anker.bottom + 10; b.className = 'iv-blase iv-blase--unten'; }
    b.style.left = Math.round(links) + 'px';
    b.style.top = Math.round(oben) + 'px';
    blaseAnker = knopfKnoten;
  }

  function versteckeBlase() {
    if (blaseKnoten) blaseKnoten.hidden = true;
    if (blaseAnker) blaseAnker.className = blaseAnker.className.replace(' iv-hilfe--offen', '');
    blaseAnker = null;
  }

  /*
   * Darf ein überfahrener (i) die Blase übernehmen?
   *
   * Der Fall, der die Regel nötig macht: Wird der Knopf, dem die offene Blase
   * gehört, durch ein Neuzeichnen aus dem Dokument entfernt — das passiert
   * regelmäßig, wenn die Live-Preise eintreffen oder sortiert wird —, dann
   * feuert sein mouseleave nie. Der Anker zeigte danach auf einen abgehängten
   * Knoten, und eine Sperre "nur wenn gar kein Anker gesetzt ist" legte damit
   * JEDEN weiteren (i) still: Man fuhr einen anderen an und bekam den Text des
   * verschwundenen zu sehen. Ein toter Anker zählt deshalb wie keiner.
   *
   * Festgestellt heißt: per Klick aufgeklappt. Die bleibt stehen, bis der Kunde
   * sie selbst schließt — sonst reißt ein zufälliges Überfahren sie wieder weg.
   */
  function darfBlaseWechseln(anker, neuerKnopf, ankerLebtNoch, ankerFestgestellt) {
    if (!anker) return true;
    if (anker === neuerKnopf) return false;
    if (!ankerLebtNoch) return true;
    return !ankerFestgestellt;
  }

  function ankerLebt() {
    if (!blaseAnker) return false;
    if (typeof document === 'undefined' || !document.contains) return true;
    return document.contains(blaseAnker);
  }

  function istFestgestellt(knoten) {
    return !!knoten && String(knoten.className).indexOf('iv-hilfe--offen') !== -1;
  }

  if (typeof document !== 'undefined') {
    document.addEventListener('click', function (ev) {
      if (blaseAnker && !blaseAnker.contains(ev.target)) versteckeBlase();
    });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') versteckeBlase(); });
    window.addEventListener('scroll', versteckeBlase, true);
    window.addEventListener('resize', versteckeBlase);
  }

  function hilfe(text) {
    var b = el('button', 'iv-hilfe');
    b.type = 'button';
    b.setAttribute('aria-label', 'Erklärung: ' + text);
    b.appendChild(icon('info'));
    b.addEventListener('mouseenter', function () {
      /* Toten Anker zuerst wegräumen: Sonst bliebe die Blase des inzwischen
       * entfernten (i) stehen und behielte ihren alten Text. */
      if (blaseAnker && !ankerLebt()) versteckeBlase();
      if (darfBlaseWechseln(blaseAnker, b, ankerLebt(), istFestgestellt(blaseAnker))) zeigeBlase(b, text);
    });
    b.addEventListener('mouseleave', function () {
      if (blaseAnker === b && b.className.indexOf('iv-hilfe--offen') === -1) versteckeBlase();
    });
    b.addEventListener('focus', function () { zeigeBlase(b, text); });
    b.addEventListener('blur', function () { if (blaseAnker === b) versteckeBlase(); });
    b.addEventListener('click', function (ev) {
      ev.stopPropagation();
      ev.preventDefault();
      var offen = b.className.indexOf('iv-hilfe--offen') !== -1;
      versteckeBlase();
      if (!offen) { b.className += ' iv-hilfe--offen'; zeigeBlase(b, text); }
    });
    return b;
  }

  function mitHilfe(knoten, text) {
    if (text) knoten.appendChild(hilfe(text));
    return knoten;
  }

  /*
   * Herstellermarke. Liegt für den Hersteller eine Logodatei vor, wird sie
   * gezeigt; sonst der Name als Wortmarke. Logos sind geschützte Zeichen — sie
   * kommen ausschließlich aus abgelegten Dateien, nie aus fremden Quellen zur
   * Laufzeit. Eintragen: LOGOS['BYD'] = 'hersteller-byd.svg'.
   *
   * Die Liste steht in DIESER Datei, weil hier gezeichnet wird;
   * tools/shopify-bauen.js liest sie von hier, um die Assets zu benennen, und
   * ein Test hält beide deckungsgleich.
   */
  var LOGOS = {
    AlphaESS: 'hersteller-alphaess.webp',
    AXITEC: 'hersteller-axitec.webp',
    BYD: 'hersteller-byd.webp',
    Deye: 'hersteller-deye.webp',
    Dyness: 'hersteller-dyness.webp',
    Felicity: 'hersteller-felicity.webp',
    Fronius: 'hersteller-fronius.webp',
    GoodWe: 'hersteller-goodwe.webp',
    Growatt: 'hersteller-growatt.webp',
    Huawei: 'hersteller-huawei.webp',
    KOSTAL: 'hersteller-kostal.webp',
    Pylontech: 'hersteller-pylontech.webp',
    SMA: 'hersteller-sma.webp',
    /* Als SVG geliefert (2026-08-14) — die Bau-Kette kennt den Typ, das Snippet
     * bettet ihn als image/svg+xml ein. Kein Umweg über WebP nötig. */
    SolarEdge: 'hersteller-solaredge.svg',
    SolaX: 'hersteller-solax.webp',
    Sungrow: 'hersteller-sungrow.webp',
    // Ohne Datei bleibt es bei der Wortmarke — derzeit nur LG. Logos sind
    // geschützte Zeichen: Sie kommen ausschließlich aus abgelegten Dateien,
    // nie aus fremden Quellen zur Laufzeit.
  };

  /*
   * Zwei Wege zur Logo-Adresse, weil Shopify keine Ordner in assets/ kennt:
   *  - logos: { 'BYD': '<vollständige URL>' } — die Section füllt das aus
   *    asset_url bzw. das Snippet mit eingebetteten Daten-URIs.
   *  - logo_basis_url + Dateiname — der einfache Weg der Standalone-Seite.
   */
  function logoAdresse(name) {
    var k = konfig();
    if (k.logos && k.logos[name]) return k.logos[name];
    if (k.logo_basis_url && LOGOS[name]) return k.logo_basis_url + LOGOS[name];
    return null;
  }

  function herstellerMarke(name, klasseZusatz) {
    var adresse = logoAdresse(name);
    if (adresse) {
      var huelle = el('span', 'iv-marke' + (klasseZusatz ? ' ' + klasseZusatz : ''));
      var bild = el('img', 'iv-marke__logo');
      bild.src = adresse;
      bild.alt = name;
      bild.loading = 'lazy';
      // Fällt das Bild aus (falscher Pfad, Asset fehlt), erscheint die
      // Wortmarke statt eines kaputten Bildsymbols.
      bild.addEventListener('error', function () {
        var ersatz = el('span', 'iv-marke iv-marke--text', name);
        if (huelle.parentNode) huelle.parentNode.replaceChild(ersatz, huelle);
      });
      huelle.appendChild(bild);
      return huelle;
    }
    return el('span', 'iv-marke iv-marke--text' + (klasseZusatz ? ' ' + klasseZusatz : ''), name);
  }

  /*
   * Spannungsklassen. Sie stehen als Kennzeichnung an der Baureihe und als
   * Filter zur Verfügung — kombinierbar sind sie ohnehin nicht, das erzwingen
   * schon die Freigaben. Die Erklärung sagt in einem Satz, worin der
   * Unterschied für den Kunden besteht.
   */
  var KLASSEN = {
    hochvolt: {
      name: 'Hochvolt',
      kurz: 'HV',
      erklaerung: 'Hochvolt-Speicher arbeiten mit 100 bis 500 Volt und werden direkt an den '
        + 'Batterieeingang eines Hybrid-Wechselrichters gehängt. Sie sind der Standard für neue '
        + 'Hausanlagen: höhere Wirkungsgrade, dünnere Leitungen, meist als Turm gestapelt und in '
        + 'Modulschritten erweiterbar. Ein Hochvolt-Speicher passt nie an einen Niedervolt-Wechselrichter.',
    },
    niedervolt: {
      name: 'Niedervolt 48 V',
      kurz: '48 V',
      erklaerung: 'Niedervolt-Speicher arbeiten mit rund 48 Volt. Sie stammen aus der Insel- und '
        + 'Notstromwelt, sind oft günstiger und werden nicht gestapelt, sondern parallel ergänzt. '
        + 'mehrere gleiche Geräte nebeneinander. Wegen der niedrigen Spannung fließen höhere Ströme, '
        + 'was dickere Leitungen verlangt. Ein Niedervolt-Speicher passt nie an einen '
        + 'Hochvolt-Wechselrichter; welche Geräte zusammengehören, sagt die Herstellerliste.',
    },
  };

  function klasse(id) { return KLASSEN[id] || KLASSEN.hochvolt; }

  /*
   * Jeder Weg nach außen — Produktseite wie Kontakt — öffnet einen neuen Tab.
   * Der Berater ist ein Arbeitsblatt: Wer etwas nachschlägt, will danach
   * weitervergleichen und nicht seine Auswahl verloren haben. rel=noopener ist
   * dabei Pflicht, sonst kann die Zielseite auf das öffnende Fenster zugreifen.
   */
  function shopLink(url, text, klasseName) {
    var a = el('a', klasseName, text);
    a.href = url;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.appendChild(icon('extern', 'iv-icon--klein'));
    a.setAttribute('aria-label', text + ' (öffnet in neuem Tab)');
    return a;
  }

  /*
   * Produktadresse mit Varianten-Parameter: /products/<handle>?variant=<id>.
   * Ohne ihn landet der Kunde auf der Produktseite mit der Standardvariante —
   * bei einem Speicher, den es in vier Größen gibt, also fast immer auf der
   * falschen. Fehlt die ID, bleibt es beim Produktlink.
   */
  function produktAdresse(handle, varianteId) {
    if (!handle) return null;
    var url = konfigWert('produkt_basis_url', 'https://inselvolt.de/products/') + handle;
    if (varianteId) url += '?variant=' + encodeURIComponent(varianteId);
    return url;
  }

  function kontaktLink(text, klasseName, url) {
    return shopLink(url || konfigWert('kontakt_url', 'https://inselvolt.de/pages/kontakt'),
      text, klasseName);
  }

  // „5,12 – 12,8": nur die Zahlen — die Kennzahlen im Kopf setzen die Einheit
  // als eigenes, kleineres Element daneben.
  function spanneZahl(werte) {
    var zahlen = werte.filter(istZahl);
    if (!zahlen.length) return null;
    var min = Math.min.apply(null, zahlen);
    var max = Math.max.apply(null, zahlen);
    return min === max ? nf.format(min) : nf.format(min) + ' – ' + nf.format(max);
  }

  // „5,12 – 12,8 kWh" statt „5,12 kWh – 12,8 kWh": Die Einheit einmal am Ende.
  function spanne(werte, einheit) {
    var text = spanneZahl(werte);
    return text === null ? null : text + ' ' + einheit;
  }

  // -------------------------------------------------------- Schlüssel ------

  function schluesselVon(e, modus) {
    return modus === 'speicher' ? e.speicher_id + '|' + e.groesse : e.wr_variante_id;
  }

  function familienSchluessel(e, modus) {
    return modus === 'speicher' ? e.speicher_id : e.wr_familie_id;
  }

  function familienName(e, modus) {
    return modus === 'speicher' ? e.name : (e.wr_familie_name || e.name);
  }

  function preisVon(e) { return e.preis || {}; }

  // ------------------------------------------------------- Gruppierung -----

  /*
   * Eine Baureihe, viele Größen: „BYD Battery-Box HVS+" viermal untereinander
   * zu zeigen, nur weil es vier Größen gibt, macht die Liste lang und die
   * Unterschiede unsichtbar. Deshalb eine Gruppe je Baureihe, darin eine Zeile
   * je Variante — der Vergleich, auf den es ankommt, steht dann direkt
   * untereinander.
   *
   * Die Reihenfolge der GRUPPEN folgt der gewählten Sortierung: Jede Gruppe
   * erbt den Rang ihrer besten Variante. Innerhalb der Gruppe wird in der
   * Voreinstellung nach Größe sortiert, weil das der Reihenfolge im Datenblatt
   * entspricht.
   *
   * Rückgabe: { gruppen: [...], trennerAb: <Index> }. `trennerAb` ist die
   * Stelle, ab der Baureihen ohne Shop-Artikel beginnen — die Oberfläche setzt
   * dort ihre Trennüberschrift. Ohne Voreinstellung ist sie null.
   */
  function gruppiere(eintraege, modus, optionen) {
    var o = optionen || {};
    var index = {};
    var reihenfolge = [];

    eintraege.forEach(function (e) {
      var schluessel = familienSchluessel(e, modus);
      if (!index[schluessel]) {
        index[schluessel] = {
          schluessel: schluessel,
          hersteller: e.hersteller,
          name: familienName(e, modus),
          eintraege: [],
        };
        reihenfolge.push(index[schluessel]);
      }
      index[schluessel].eintraege.push(e);
    });

    /*
     * Lieferbarkeit je Baureihe, für Badge und Reihenfolge: 2 = alle Varianten
     * sofort bestellbar, 1 = ein Teil, 0 = keine (oder unbekannt — ohne
     * Preiszuordnung gibt es keine belegbare Lieferaussage).
     */
    reihenfolge.forEach(function (g) {
      var lieferbar = 0;
      var gelistet = 0;
      g.eintraege.forEach(function (e) {
        if (!e.preis) return;
        var imShop = modus === 'speicher' ? e.preis.speicher_handle : e.preis.wr_handle;
        if (imShop) gelistet++;
        var v = modus === 'speicher' ? e.preis.speicher_verfuegbar : e.preis.wr_verfuegbar;
        if (v === true) lieferbar++;
      });
      g.lieferbar_anzahl = lieferbar;
      g.shop_anzahl = gelistet;
      g.liefer_klasse = lieferbar === 0 ? 0 : (lieferbar === g.eintraege.length ? 2 : 1);
    });

    if (o.sortierung && o.sortierung !== 'empfehlung') {
      /* Der Aufrufer hat ausdrücklich sortiert — dann gilt seine Ordnung,
       * innerhalb der Gruppe wie zwischen den Gruppen. */
      return { gruppen: reihenfolge, trennerAb: null };
    }

    reihenfolge.forEach(function (g) {
      g.eintraege.sort(function (a, b) {
        var wa = modus === 'speicher' ? a.kapazitaet_kwh : a.ac_kw;
        var wb = modus === 'speicher' ? b.kapazitaet_kwh : b.ac_kw;
        if (istZahl(wa) && istZahl(wb) && wa !== wb) return wa - wb;
        return String(a.name + a.groesse).localeCompare(String(b.name + b.groesse), 'de', { numeric: true });
      });
    });

    /*
     * Nur in der Voreinstellung. Zwei Blöcke:
     *
     *  BLOCK 1 — Baureihen, die Artikel aus unserem Shop enthalten.
     *     Sortiert nach der Anzahl dort verfügbarer Produkte, absteigend;
     *     bei Gleichstand nach der Anzahl überhaupt gelisteter, dann nach
     *     Herstellerrang und Alphabet. Wer etwas kaufen will, soll nicht an
     *     Baureihen vorbeiscrollen müssen, die wir gar nicht führen.
     *
     *  BLOCK 2 — alles Übrige. Hier gibt es keine Shop-Zahl, nach der man
     *     ordnen könnte; also Hersteller mit Logo zuerst, dann alphabetisch —
     *     dieselbe Rangfolge wie in den Auswahlfeldern.
     *
     * „Enthält Shop-Artikel" heißt: mindestens ein Gerät der Baureihe ist im
     * Shop zugeordnet. Eine zugeordnete, aber gerade nicht lieferbare
     * Baureihe bleibt damit in Block 1 — sie ist Teil des Sortiments, nur
     * heute nicht am Lager. Das ist der Unterschied zwischen „führen wir"
     * und „liegt gerade da".
     */
    var imShop = [];
    var uebrige = [];
    reihenfolge.forEach(function (g) {
      (g.shop_anzahl > 0 ? imShop : uebrige).push(g);
    });

    imShop.sort(function (a, b) {
      if (a.lieferbar_anzahl !== b.lieferbar_anzahl) return b.lieferbar_anzahl - a.lieferbar_anzahl;
      if (a.shop_anzahl !== b.shop_anzahl) return b.shop_anzahl - a.shop_anzahl;
      return nachHerstellerUndName(a, b);
    });
    uebrige.sort(nachHerstellerUndName);

    return { gruppen: imShop.concat(uebrige), trennerAb: imShop.length };
  }

  /* Rangfolge der Hersteller kommt aus der Engine (WESENTLICHE_HERSTELLER) —
   * eine zweite Kopie hier würde auseinanderlaufen. */
  function herstellerRang(name) {
    var engine = (typeof window !== 'undefined' && window.IVBeraterEngine)
      || (typeof require === 'function' ? require('../engine/berater-engine.js') : null);
    return engine ? engine.herstellerRang(name) : 1;
  }

  function nachHerstellerUndName(a, b) {
    var ra = herstellerRang(a.hersteller);
    var rb = herstellerRang(b.hersteller);
    if (ra !== rb) return ra - rb;
    var h = String(a.hersteller).localeCompare(String(b.hersteller), 'de');
    return h !== 0 ? h : String(a.name).localeCompare(String(b.name), 'de');
  }

  // ------------------------------------------------------------- Kachel ----

  /*
   * Eine Baureihe als aufklappbare Kachel.
   *
   * Der Kopf ist die Schaltfläche: Neun Baureihen gleichzeitig aufgeklappt
   * ergaben eine Seite, durch die man nur noch scrollt. Zugeklappt bleibt das
   * Wesentliche sichtbar — Marke, Baureihe, Anzahl, Spanne, Preis ab,
   * Lieferbarkeit.
   *
   * optionen:
   *   offen        — beim Zeichnen aufgeklappt?
   *   aufWechsel   — (schluessel, offen) nach jedem Auf-/Zuklappen
   *   koerper      — (gruppe) => Knoten; ohne Angabe die Varianten-Tabelle
   *   … alle weiteren Felder gehen unverändert an tabelle() weiter.
   */
  function kachel(gruppe, modus, optionen) {
    var o = optionen || {};
    var abschnitt = el('section', 'iv-familie');
    var eintraege = gruppe.eintraege;
    var erste = eintraege[0];
    var offen = !!o.offen;
    if (offen) abschnitt.className += ' iv-familie--offen';

    /*
     * Der Kopf war bis 2026-08-16 ein <button>. Seit die Kennzahlen eigene
     * (i)-Erklärungen tragen, geht das nicht mehr: Ein button darf keine
     * Schaltflächen enthalten. Deshalb ein div mit role="button" und eigener
     * Tastaturbedienung — für Leser und Tastatur verhält er sich unverändert.
     */
    var kopf = el('div', 'iv-familie__kopf');
    kopf.setAttribute('role', 'button');
    kopf.tabIndex = 0;
    function umschalten() {
      /*
       * An Ort und Stelle öffnen und schließen, statt die ganze Liste neu zu
       * zeichnen. Der Neuaufbau ließ den Blick springen: Die Scrollposition
       * blieb stehen, während sich der Inhalt darunter komplett austauschte —
       * man wusste nicht mehr, wo man war. Jetzt bewegt sich nur diese eine
       * Gruppe, alles darüber bleibt exakt an seinem Platz.
       */
      var jetztOffen = koerper.hidden;
      kopf.setAttribute('aria-expanded', jetztOffen ? 'true' : 'false');
      abschnitt.className = 'iv-familie' + (jetztOffen ? ' iv-familie--offen' : '');
      if (jetztOffen) {
        if (!koerper.firstChild) fuelleKoerper();
        koerper.hidden = false;
      } else {
        koerper.hidden = true;
      }
      if (o.aufWechsel) o.aufWechsel(gruppe.schluessel, jetztOffen);
    }
    /* Die (i)-Knöpfe im Kopf stoppen ihre Klicks selbst (hilfe()); hier kommt
     * also nur an, was wirklich klappen soll. */
    kopf.addEventListener('click', umschalten);
    kopf.addEventListener('keydown', function (ev) {
      /* Nur wenn der Kopf selbst den Fokus hat — Enter auf einem (i) im Kopf
       * öffnet die Erklärung und darf nicht zusätzlich klappen. */
      if (ev.target !== kopf) return;
      if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
        ev.preventDefault();
        umschalten();
      }
    });
    kopf.setAttribute('aria-expanded', offen ? 'true' : 'false');

    var titelBlock = el('span', 'iv-familie__titel-block');
    titelBlock.appendChild(herstellerMarke(gruppe.hersteller));
    titelBlock.appendChild(el('span', 'iv-familie__name', gruppe.name));

    var meta = el('span', 'iv-familie__meta');
    function metaStueck(iconName, text, extraKlasse) {
      if (!text) return;
      var st = el('span', 'iv-familie__meta-stueck' + (extraKlasse ? ' ' + extraKlasse : ''));
      st.appendChild(icon(iconName, 'iv-icon--klein'));
      st.appendChild(el('span', null, text));
      meta.appendChild(st);
    }
    metaStueck(modus === 'speicher' ? 'speicher' : 'wechselrichter',
      eintraege.length + (eintraege.length === 1
        ? (modus === 'speicher' ? ' Größe' : ' Gerät')
        : (modus === 'speicher' ? ' Größen' : ' Geräte')));
    /*
     * Lieferbarkeit als Kopfzeilen-Merkmal: Sie bestimmt (in der Voreinstellung)
     * die Reihenfolge der Baureihen — dann muss der Grund auch dort ablesbar
     * sein, sonst wirkt die Ordnung willkürlich. „Keine Angabe" bleibt stumm:
     * Ohne Preiszuordnung gibt es keine belegbare Lieferaussage.
     */
    if (gruppe.liefer_klasse === 2) {
      metaStueck('haken', 'alle sofort bestellbar', 'iv-familie__meta-stueck--ok');
    } else if (gruppe.liefer_klasse === 1) {
      metaStueck('haken', gruppe.lieferbar_anzahl + ' von ' + eintraege.length + ' sofort bestellbar',
        'iv-familie__meta-stueck--teils');
    }
    titelBlock.appendChild(meta);
    kopf.appendChild(titelBlock);

    /*
     * Technische Eckdaten als große Kennzahlen neben Logo und Name
     * (2026-08-16). Vorher standen sie als 13-px-Merkmalzeile unter dem
     * Namen — dabei sind sie die Angabe, nach der überhaupt gesucht wird
     * („was schafft die Kombination?"). Jetzt nutzen sie die Kopfhöhe.
     *
     * Lade- und Entladeleistung gelten für die PAARUNG, nicht für das Gerät
     * allein: Die Werte kommen aus derselben min()-Rechnung wie die Tabelle
     * darunter. Die Beschriftungen erklären sich über dieselben (i)-Texte
     * wie die Spaltenköpfe (spalten()) — eine Quelle, kein Auseinanderlaufen.
     * Spannen („3 – 6") und der „bis"-Vorbehalt bei unvollständiger Rechnung
     * bleiben erhalten (Invariante 3: unbekannte Glieder werden benannt).
     */
    var kennzahlen = el('span', 'iv-familie__kennzahlen');
    var kopfSpalten = spalten(modus);
    function spaltenHilfe(label) {
      for (var i = 0; i < kopfSpalten.length; i++) {
        if (kopfSpalten[i].label === label) return kopfSpalten[i].hilfe;
      }
      return null;
    }
    function kennzahl(label, hilfeText, wertText, einheit, vorbehalt) {
      if (!wertText) return;
      var st = el('span', 'iv-fkz');
      var wert = el('span', 'iv-fkz__wert');
      if (vorbehalt) wert.appendChild(el('span', 'iv-fkz__vorbehalt', vorbehalt));
      wert.appendChild(document.createTextNode(wertText));
      if (einheit) wert.appendChild(el('span', 'iv-fkz__einheit', einheit));
      st.appendChild(wert);
      var beschriftung = el('span', 'iv-fkz__label', label);
      if (hilfeText && o.hilfen !== false) beschriftung.appendChild(hilfe(hilfeText));
      st.appendChild(beschriftung);
      kennzahlen.appendChild(st);
    }
    if (modus === 'speicher') {
      kennzahl('Kapazität', spaltenHilfe('Kapazität'),
        spanneZahl(eintraege.map(function (e) { return e.kapazitaet_kwh; })), 'kWh');
    } else {
      kennzahl('AC-Leistung', spaltenHilfe('AC-Leistung'),
        spanneZahl(eintraege.map(function (e) { return e.ac_kw; })), 'kW');
    }
    var entladen = eintraege.map(function (e) {
      return e.kombi && e.kombi.entladen ? e.kombi.entladen.kw : null;
    });
    kennzahl('Max. Entladeleistung', spaltenHilfe('Entladen'),
      spanneZahl(entladen), 'kW',
      richtungUnvollstaendig(eintraege, 'entladen') ? 'bis' : null);
    var laden = eintraege.map(function (e) {
      return e.kombi && e.kombi.laden ? e.kombi.laden.kw : null;
    });
    kennzahl('Max. Ladeleistung', spaltenHilfe('Laden'),
      spanneZahl(laden), 'kW',
      richtungUnvollstaendig(eintraege, 'laden') ? 'bis' : null);
    var preise = eintraege.map(function (e) {
      return modus === 'speicher' ? preisVon(e).speicher_preis_cents : preisVon(e).wr_preis_effektiv_cents;
    }).filter(istZahl);
    if (preise.length) {
      kennzahl('Preis', modus === 'speicher'
        ? 'Günstigster Speicher dieser Baureihe im inselvolt-Shop. Ohne Wechselrichter und ohne Montage.'
        : 'Günstigster Wechselrichter dieser Baureihe im inselvolt-Shop. Kostenpflichtige Freischaltungen sind schon eingerechnet.',
        euroZahl(Math.min.apply(null, preise)), '€', 'ab');
    }
    if (kennzahlen.firstChild) kopf.appendChild(kennzahlen);

    var rechts = el('span', 'iv-familie__rechts');
    var kl = klasse(erste.spannungsklasse);
    var klTag = el('span', 'iv-tag iv-tag--klasse iv-tag--' + (erste.spannungsklasse || 'hochvolt'), kl.name);
    klTag.title = kl.erklaerung;
    rechts.appendChild(klTag);
    /*
     * Hier stand bis 2026-08-15 die Marke „Werte unvollständig".
     *
     * Sie war eine Warnung vor etwas, das direkt daneben schon dasteht: Fehlt
     * ein Glied der min()-Rechnung, tragen die Werte selbst ein „bis" („bis
     * 5,12 kW"), und in der Tabelle steht „nicht verfügbar". Die Marke sagte
     * dasselbe ein zweites Mal, nur alarmierender — und sie hing an der ganzen
     * Baureihe, obwohl meist nur eine Größe betroffen war.
     *
     * Der Vorbehalt selbst bleibt unangetastet (Invariante 3): Er steht am
     * Wert, wo er hingehört.
     */
    rechts.appendChild(icon('pfeil', 'iv-familie__pfeil'));
    kopf.appendChild(rechts);
    abschnitt.appendChild(kopf);

    var koerper = el('div', 'iv-familie__koerper');
    koerper.hidden = !offen;
    abschnitt.appendChild(koerper);

    function fuelleKoerper() {
      koerper.appendChild(o.koerper ? o.koerper(gruppe) : tabelle(eintraege, modus, o));

      var auflagen = [];
      eintraege.forEach(function (e) {
        (e.einschraenkungen || []).forEach(function (t) { if (auflagen.indexOf(t) === -1) auflagen.push(t); });
      });
      if (!auflagen.length) return;
      /*
       * „Auflagen der Herstellerfreigabe" war Behördendeutsch. Gemeint ist:
       * Die Freigabe gilt nur, wenn diese Punkte erfüllt sind.
       */
      var hinweis = el('details', 'iv-familie__auflagen');
      var summe = el('summary');
      summe.appendChild(icon('warnung', 'iv-icon--klein'));
      /*
       * „Eine Bedingung, damit die Kombination bestätigt bleibt" war umständlich
       * und klang nach Kleingedrucktem, das man besser nicht liest. Gemeint ist
       * schlicht: Der Hersteller knüpft die Freigabe an diese Punkte. Kürzer
       * und ruhiger — aber weiterhin „Bedingung", nicht „Hinweis": Eine
       * Firmware-Anforderung ist keine Empfehlung.
       */
      summe.appendChild(el('span', null, auflagen.length === 1
        ? 'Eine Bedingung des Herstellers'
        : auflagen.length + ' Bedingungen des Herstellers'));
      hinweis.appendChild(summe);
      var ul = el('ul');
      auflagen.forEach(function (t) { ul.appendChild(el('li', null, t)); });
      hinweis.appendChild(ul);
      koerper.appendChild(hinweis);
    }

    if (offen) fuelleKoerper();
    return abschnitt;
  }

  /*
   * „bis", sobald ein Glied der min()-Rechnung dieser Richtung fehlt. Ohne
   * diesen Vorbehalt stünde in der Kachel eine Zusage, die die Datenbasis
   * nicht deckt (Invariante 3: unbekannte Glieder werden benannt, nie mit
   * einem Schätzwert gefüllt).
   */
  function richtungUnvollstaendig(eintraege, richtung) {
    return eintraege.some(function (e) {
      return e.kombi && e.kombi[richtung] && e.kombi[richtung].unvollstaendig;
    });
  }

  // ---------------------------------------------------- Varianten-Tabelle ---

  /*
   * Spalten je Richtung. Auf schmalen Schirmen bricht die Tabelle in Blöcke um
   * (CSS); damit die Werte dort noch zuzuordnen sind, trägt jede Zelle ihr
   * Label als eigenes Element.
   */
  function spalten(modus) {
    if (modus === 'speicher') {
      return [
        { label: 'Größe', klasse: 'iv-vzeile__haupt', sort: { auf: 'kapazitaet_auf', ab: 'kapazitaet_ab', standard: 'auf' },
          hilfe: 'So nennt der Hersteller diese Größe. Der Name richtet sich nach der Zahl der Module im Turm.' },
        /*
         * Einheiten stehen EINMAL im Spaltenkopf, die Zellen tragen nur die
         * Zahl (rechtsbündig, Tabellenziffern): „13,8 kWh · 5 kW · 5 kW" je
         * Zeile las sich als Textwüste — beim Vergleichen zählt der
         * Ziffernsprung, nicht die dritte Wiederholung der Einheit.
         * Der Euro bleibt an den Preisen: Währung ist keine Wiederholung,
         * sondern Pflichtangabe.
         */
        { label: 'Kapazität', einheit: 'kWh', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'kapazitaet_auf', ab: 'kapazitaet_ab', standard: 'ab' },
          hilfe: 'So viel Strom können Sie wirklich entnehmen. Der Wert liegt unter der aufgedruckten Kapazität. Ein Rest bleibt immer in der Batterie, damit sie länger hält.' },
        { label: 'Entladen', einheit: 'kW', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'entladen_auf', ab: 'entladen_ab', standard: 'ab' },
          hilfe: 'So viel Leistung gibt diese Kombination gleichzeitig ins Haus ab. Es zählt immer der kleinste Wert von Speicher und Wechselrichter. Ein Wasserkocher braucht rund 2 kW, eine Wärmepumpe 2 bis 3 kW.' },
        { label: 'Laden', einheit: 'kW', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'laden_auf', ab: 'laden_ab', standard: 'ab' },
          hilfe: 'So schnell füllt sich der Speicher. Auch hier zählt der kleinste Wert. Ein hoher Wert lohnt sich vor allem bei einer großen PV-Anlage über Mittag.' },
        { label: 'Preis', klasse: 'iv-vzeile__preis iv-vzeile__zahl', sort: { auf: 'preis_auf', ab: 'preis_ab', standard: 'auf' },
          hilfe: 'Preis des Speichers im inselvolt-Shop. Ohne Wechselrichter und ohne Montage.' },
        { label: 'pro kWh', klasse: 'iv-vzeile__zahl', sort: { auf: 'eur_kwh_auf', ab: 'eur_kwh_ab', standard: 'auf' },
          hilfe: 'Der Speicherpreis geteilt durch die nutzbare Kapazität. Damit lassen sich unterschiedlich große Speicher fair vergleichen. Je niedriger der Wert, desto mehr Speicher bekommen Sie fürs Geld.' },
        { label: 'Verfügbar', sort: { auf: 'verfuegbar_auf', ab: 'verfuegbar_ab', standard: 'ab' },
          hilfe: 'Lagerstand im inselvolt-Shop. Es gilt die Angabe auf der Produktseite, wenn Sie bestellen.' },
      ];
    }
    return [
      { label: 'Gerät', klasse: 'iv-vzeile__haupt', sort: { auf: 'ac_auf', ab: 'ac_ab', standard: 'auf' },
        hilfe: 'So nennt der Hersteller das Gerät. Meist steht die Leistung im Namen.' },
      { label: 'AC-Leistung', einheit: 'kW', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'ac_auf', ab: 'ac_ab', standard: 'ab' },
        hilfe: 'So viel Leistung gibt der Wechselrichter höchstens ins Hausnetz ab. Damit begrenzt er auch, wie schnell sich der Speicher entladen kann.' },
      { label: 'Entladen', einheit: 'kW', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'entladen_auf', ab: 'entladen_ab', standard: 'ab' },
        hilfe: 'So viel Leistung gibt diese Kombination gleichzeitig ins Haus ab. Es zählt immer der kleinste Wert von Speicher und Wechselrichter.' },
      { label: 'Laden', einheit: 'kW', klasse: 'iv-vzeile__zahl iv-vzeile__eng', sort: { auf: 'laden_auf', ab: 'laden_ab', standard: 'ab' },
        hilfe: 'So schnell füllt sich der Speicher. Auch hier zählt der kleinste Wert.' },
      { label: 'Preis', klasse: 'iv-vzeile__preis iv-vzeile__zahl', sort: { auf: 'wr_preis_auf', ab: 'wr_preis_ab', standard: 'auf' },
        hilfe: 'Preis des Wechselrichters im inselvolt-Shop. Kostenpflichtige Freischaltungen sind schon eingerechnet, beim KOSTAL PLENTICORE zum Beispiel die PLENTICOIN.' },
      { label: 'System gesamt', klasse: 'iv-vzeile__zahl', sort: { auf: 'gesamt_auf', ab: 'gesamt_ab', standard: 'auf' },
        hilfe: 'Speicher und Wechselrichter zusammen, mit allen nötigen Freischaltungen. Ohne Montage, Zubehör und Elektroarbeiten.' },
      { label: 'Verfügbar', sort: { auf: 'verfuegbar_auf', ab: 'verfuegbar_ab', standard: 'ab' },
        hilfe: 'Lagerstatus im inselvolt-Shop. Maßgeblich ist die Angabe auf der Produktseite zum Bestellzeitpunkt.' },
    ];
  }

  /*
   * Die Tabelle einer Baureihe.
   *
   * optionen:
   *   vergleich   — { ausgewaehlt: [id], aufWechsel(id, an) } oder nichts.
   *                 Ohne Angabe entfällt die Auswahlspalte; das Overlay hat
   *                 keine Vergleichsleiste, zu der ein Häkchen führen könnte.
   *                 `aufWechsel` darf `false` zurückgeben und lehnt die Wahl
   *                 damit ab (Obergrenze erreicht) — die Entscheidung bleibt
   *                 beim Aufrufer, weil nur er den laufenden Stand kennt.
   *   sortierung  — aktuelle Sortierung (für die Pfeile im Spaltenkopf)
   *   aufSortierung — (neu) beim Klick auf einen Spaltenkopf. Ohne Angabe sind
   *                 die Köpfe reine Beschriftung.
   *   aufDetail   — (eintrag) für den „Details"-Knopf. Ohne Angabe kein Knopf.
   *   aufProdukt  — (eintrag, handle) nach dem Klick auf „Zum Produkt"
   *                 (Messung — der Link selbst entsteht hier).
   *   hilfen      — (false) unterdrückt die (i)-Erklärungen
   */
  function tabelle(eintraege, modus, optionen) {
    var o = optionen || {};
    var mitWahl = !!o.vergleich;
    var huelle = el('div', 'iv-varianten');
    var tab = el('table', 'iv-vtabelle' + (mitWahl ? '' : ' iv-vtabelle--ohne-wahl'));
    var sp = spalten(modus);

    var thead = el('thead');
    var kopfzeile = el('tr');
    if (mitWahl) kopfzeile.appendChild(el('th', 'iv-vtabelle__wahl', ''));
    sp.forEach(function (s) {
      var th = el('th', s.klasse || null);
      th.scope = 'col';
      /*
       * Hülle um Beschriftung und (i) (2026-08-16): Die Spalten haben feste
       * Breiten, und „Kapazität (kWh) ↕ (i)" passt darin nicht in eine Zeile.
       * Ohne diese Hülle setzte der Umbruch das (i) allein und versetzt unter
       * den Kopf. Als gemeinsamer Flex-Container bricht der Kopf geordnet um
       * und bleibt an seiner Kante ausgerichtet — nichts läuft über die
       * Spaltengrenze in den Nachbarn.
       */
      var kopfHuelle = el('span', 'iv-vtabelle__kopf');
      th.appendChild(kopfHuelle);
      if (s.sort && o.aufSortierung) {
        /*
         * Der Spaltenkopf sortiert — erster Klick in der Richtung, die bei
         * dieser Größe üblich ist (Preise aufsteigend, Leistung absteigend),
         * zweiter Klick dreht um. Das setzt dieselbe Sortierung wie das
         * Auswahlfeld darüber, damit es nur EINE Ordnung gibt.
         */
        var aktiv = o.sortierung === s.sort.auf ? 'auf'
          : (o.sortierung === s.sort.ab ? 'ab' : null);
        var knopfKopf = knopf('iv-vtabelle__sort' + (aktiv ? ' iv-vtabelle__sort--aktiv' : ''), null, function () {
          o.aufSortierung(aktiv === s.sort.standard
            ? (s.sort.standard === 'auf' ? s.sort.ab : s.sort.auf)
            : s.sort[s.sort.standard]);
        });
        knopfKopf.appendChild(el('span', null, s.label));
        /*
         * Einheit als eigenes Element: Die Kopfzeile versalisiert per CSS,
         * und aus „kWh" darf kein „KWH" werden — Einheiten sind
         * Schreibweisen-genau.
         */
        if (s.einheit) knopfKopf.appendChild(el('span', 'iv-vtabelle__einheit', '(' + s.einheit + ')'));
        knopfKopf.appendChild(el('span', 'iv-vtabelle__pfeil', aktiv === 'auf' ? '▲' : (aktiv === 'ab' ? '▼' : '↕')));
        knopfKopf.title = 'Nach ' + s.label + ' sortieren';
        kopfHuelle.appendChild(knopfKopf);
        th.setAttribute('aria-sort', aktiv === 'auf' ? 'ascending' : (aktiv === 'ab' ? 'descending' : 'none'));
      } else {
        kopfHuelle.appendChild(el('span', null, s.label));
        if (s.einheit) kopfHuelle.appendChild(el('span', 'iv-vtabelle__einheit', '(' + s.einheit + ')'));
      }
      if (s.hilfe && o.hilfen !== false) kopfHuelle.appendChild(hilfe(s.hilfe));
      kopfzeile.appendChild(th);
    });
    var aktionen = el('th', 'iv-vtabelle__aktionen', 'Aktion');
    aktionen.scope = 'col';
    kopfzeile.appendChild(aktionen);
    thead.appendChild(kopfzeile);
    tab.appendChild(thead);

    // Bestes Preis-Leistungs-Verhältnis der Baureihe — nur wenn belegt und
    // wenn es überhaupt etwas zu unterscheiden gibt.
    var kwhWerte = eintraege.map(function (e) {
      return modus === 'speicher' ? preisVon(e).speicher_eur_pro_kwh : preisVon(e).eur_pro_kwh_nutzbar;
    }).filter(istZahl);
    var bestesKwh = kwhWerte.length > 1 ? Math.min.apply(null, kwhWerte) : null;

    var tbody = el('tbody');
    eintraege.forEach(function (e) {
      tbody.appendChild(zeile(e, modus, sp, bestesKwh, o));
    });
    tab.appendChild(tbody);
    huelle.appendChild(tab);
    return huelle;
  }

  function zeile(e, modus, sp, bestesKwh, o) {
    var id = schluesselVon(e, modus);
    var tr = el('tr', 'iv-vzeile');
    var vergleich = o.vergleich;
    var ausgewaehlt = vergleich && vergleich.ausgewaehlt.indexOf(id) !== -1;
    if (ausgewaehlt) tr.className += ' iv-vzeile--gewaehlt';

    if (vergleich) {
      var wahlZelle = el('td', 'iv-vtabelle__wahl');
      var wahl = el('label', 'iv-vwahl');
      var box = el('input');
      box.type = 'checkbox';
      box.checked = ausgewaehlt;
      box.setAttribute('aria-label', 'Zum Vergleich hinzufügen: '
        + (modus === 'speicher' ? (e.bezeichnung || (e.name + ' ' + e.groesse)) : e.name));
      box.addEventListener('change', function () {
        if (vergleich.aufWechsel(id, box.checked) === false) {
          box.checked = !box.checked;
          return;
        }
        if (box.checked) {
          if (tr.className.indexOf('iv-vzeile--gewaehlt') === -1) tr.className += ' iv-vzeile--gewaehlt';
        } else {
          tr.className = tr.className.replace(' iv-vzeile--gewaehlt', '');
        }
      });
      wahl.appendChild(box);
      wahlZelle.appendChild(wahl);
      tr.appendChild(wahlZelle);
    }

    var preis = preisVon(e);
    var eurProKwh = modus === 'speicher' ? preis.speicher_eur_pro_kwh : preis.eur_pro_kwh_nutzbar;
    var preisCents = modus === 'speicher' ? preis.speicher_preis_cents : preis.wr_preis_effektiv_cents;
    var verfuegbar = modus === 'speicher' ? preis.speicher_verfuegbar : preis.wr_verfuegbar;

    var werte = modus === 'speicher'
      ? [
        // Volle Produktbezeichnung, wenn gepflegt: „LUNA2000-14-S1" sagt dem
        // Kunden etwas, „14" nicht.
        { text: e.bezeichnung || e.groesse, stark: true },
        { text: zahl(e.kapazitaet_kwh), zusatz: e.kapazitaet_dokumentiert ? null : 'hergeleitet' },
        { text: leistungsZahl(e.kombi && e.kombi.entladen) },
        { text: leistungsZahl(e.kombi && e.kombi.laden) },
        { text: euro(preisCents), stark: true },
        { text: istZahl(eurProKwh) ? euroGenau(eurProKwh) : null, hervor: istZahl(eurProKwh) && eurProKwh === bestesKwh },
        { text: verfuegbar === true ? 'sofort lieferbar' : (verfuegbar === false ? 'nicht lieferbar' : null), ampel: verfuegbar },
      ]
      : [
        { text: e.name, stark: true },
        { text: zahl(e.ac_kw) },
        { text: leistungsZahl(e.kombi && e.kombi.entladen) },
        { text: leistungsZahl(e.kombi && e.kombi.laden) },
        { text: euro(preisCents), stark: true },
        { text: euro(preis.gesamt_preis_cents) },
        { text: verfuegbar === true ? 'sofort lieferbar' : (verfuegbar === false ? 'nicht lieferbar' : null), ampel: verfuegbar },
      ];

    werte.forEach(function (w, i) {
      var td = el('td', sp[i].klasse || null);
      /*
       * Beschriftung als echtes Element statt als CSS-Pseudo-Element: Auf
       * schmalen Schirmen sind die Tabellenköpfe ausgeblendet — dort muss die
       * (i)-Erklärung trotzdem antippbar sein, und ein ::before kann keine
       * Schaltfläche enthalten. Auf breiten Schirmen blendet CSS sie aus.
       */
      var label = el('span', 'iv-vzeile__label');
      label.appendChild(el('span', null, sp[i].label));
      // Einheit auch am Mobil-Label — dort ist der Spaltenkopf ausgeblendet.
      if (sp[i].einheit) label.appendChild(el('span', 'iv-vtabelle__einheit', '(' + sp[i].einheit + ')'));
      if (sp[i].hilfe && o.hilfen !== false) label.appendChild(hilfe(sp[i].hilfe));
      td.appendChild(label);
      var inhalt = el('span', w.stark ? 'iv-vzeile__stark' : null, w.text || FEHLT);
      if (!w.text) inhalt.className = 'iv-kennzahl--offen';
      if (w.ampel === true) inhalt.className = 'iv-lager';
      if (w.ampel === false) inhalt.className = 'iv-lager iv-lager--nein';
      td.appendChild(inhalt);
      if (w.hervor) {
        var stern = el('span', 'iv-bestwert', 'bester Wert');
        stern.title = 'Niedrigster Preis pro kWh in dieser Baureihe';
        td.appendChild(stern);
      }
      if (w.zusatz) td.appendChild(el('span', 'iv-vzeile__zusatz', w.zusatz));
      tr.appendChild(td);
    });

    var aktionsZelle = el('td', 'iv-vtabelle__aktionen');
    aktionsZelle.setAttribute('data-label', 'Aktion');
    if (o.aufDetail) {
      aktionsZelle.appendChild(knopf('iv-textknopf', 'Details', function () { o.aufDetail(e); }));
    }
    var handle = modus === 'speicher' ? preis.speicher_handle : preis.wr_handle;
    var vid = modus === 'speicher' ? preis.speicher_variante_id : preis.wr_shop_variante_id;
    if (handle) {
      var a = shopLink(produktAdresse(handle, vid), 'Zum Produkt', 'iv-knopf iv-knopf--gold iv-knopf--winzig');
      if (o.aufProdukt) a.addEventListener('click', function () { o.aufProdukt(e, handle); });
      aktionsZelle.appendChild(a);
    }
    tr.appendChild(aktionsZelle);
    return tr;
  }

  /*
   * Die Trennüberschrift vor Block 2. Zurückhaltend: Sie ordnet die Liste, sie
   * wertet nicht ab — unter ihr stehen ebenso herstellerfreigegebene
   * Kombinationen wie darüber.
   */
  function trenner() {
    var h = el('h3', 'iv-familien__trenner');
    h.appendChild(el('span', null, 'Weitere Baureihen, die der Hersteller freigegeben hat'));
    /* Leerzeichen als eigener Knoten: Der Abstand kommt optisch aus dem
     * Flex-Gap, im vorgelesenen Text gäbe es ihn sonst nicht. */
    h.appendChild(document.createTextNode(' '));
    h.appendChild(el('span', 'iv-familien__trenner-zusatz',
      'Diese führen wir nicht im Shop. Preis auf Anfrage.'));
    return h;
  }

  return {
    // Bausteine
    gruppiere: gruppiere,
    kachel: kachel,
    tabelle: tabelle,
    spalten: spalten,
    trenner: trenner,
    // Helfer, die beide Oberflächen brauchen
    el: el,
    knopf: knopf,
    leere: leere,
    icon: icon,
    hilfe: hilfe,
    mitHilfe: mitHilfe,
    versteckeBlase: versteckeBlase,
    darfBlaseWechseln: darfBlaseWechseln,
    herstellerMarke: herstellerMarke,
    logoAdresse: logoAdresse,
    LOGOS: LOGOS,
    PFADE: PFADE,
    KLASSEN: KLASSEN,
    klasse: klasse,
    istZahl: istZahl,
    nf: nf,
    kw: kw,
    kwh: kwh,
    euro: euro,
    euroGenau: euroGenau,
    groesseText: groesseText,
    zahl: zahl,
    leistungsText: leistungsText,
    leistungsZahl: leistungsZahl,
    datumLang: datumLang,
    spanne: spanne,
    spanneZahl: spanneZahl,
    euroZahl: euroZahl,
    richtungUnvollstaendig: richtungUnvollstaendig,
    shopLink: shopLink,
    kontaktLink: kontaktLink,
    produktAdresse: produktAdresse,
    schluesselVon: schluesselVon,
    familienSchluessel: familienSchluessel,
    familienName: familienName,
    FEHLT: FEHLT,
  };
});
